<template>
  <div id="app">

    <cc-nav-bar v-show="shouldShowNavigation"  @site-changed="siteChanged" />

    <div class="container" >
      <!--<router-view v-slot="{ Component, route }">
        <transition name="fade">
          <component :is="Component" :key="route.path" />
        </transition>
      </router-view> -->
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component" :key="refreshIdx" />
        </transition>
      </router-view>
    </div>

    <!-- Tours overlay (Stage 1). Only show after login; hide on auth/wizard/verify routes. -->
    <template v-if="shouldShowNavigation && $store.getters.isLogged">
      <cc-welcome-modal />
      <cc-tour-runner />
    </template>

    <!-- Shared "Request an upgrade" dialog (free-tier feature). Opened via the
         event bus from the tier-limit prompts and the Plan & Billing page. -->
    <cc-upgrade-request />
  </div>
</template>


<script>
import CcNavBar from './components/root/navbar.vue'

// todo - try to remove this - only some stile issues pending for the grid!!!
// import 'bootstrap-sass/assets/stylesheets/_bootstrap.scss'

import 'element-plus/theme-chalk/index.css'

import './assets/sass/prodexis.css'

import { useRoute } from 'vue-router'


export default {
  name: 'Prodexis',
  components: {
    CcNavBar,
  },

  data() {
    return {
      refreshIdx: 0,
    };
  },

  setup() {
    const route = useRoute()

    return {
      route
    }
  },

  methods: {
    siteChanged(siteId) {
      this.refreshIdx++;
    },
  },

  computed: {
    shouldShowNavigation() {
      var isAuth = this.route.path.indexOf('/auth') !== -1
      var isVerify = this.route.path.indexOf('/verify-email') !== -1
      // Wizard renders its own minimal header (logo + tenant info + Sign out);
      // hide the full app menu while the user is in setup.
      var isWizard = this.route.path.indexOf('/wizard') !== -1
      return this.route.path ? (!isAuth && !isVerify && !isWizard) : false
    },

    /*getAppStyle() {
      return this.globalMetadata ? this.globalMetadata.appStyle : null
    },*/
  },
}
</script>

<style scoped>
div.container {
  width: 100%;
  margin-top: 84px; /* for the main menu*/
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

</style>
